import catalog from "../../content/catalog.json";
import cloudpaws from "../../content/cloudpaws.json";
import finlite from "../../content/finlite.json";
import greenshop from "../../content/greenshop.json";
import mapleclinic from "../../content/mapleclinic.json";
import northwind from "../../content/northwind.json";

import type {
  Achievement,
  Client,
  Contract,
  Recommendation,
  Skill,
  Tool,
} from "../types";
import { loadContent } from "./loader";
import { contentFileSchema } from "./schemas";

const rawFiles: unknown[] = [
  greenshop,
  cloudpaws,
  mapleclinic,
  northwind,
  finlite,
  catalog,
];

const files = rawFiles.map((raw) => loadContent(raw, contentFileSchema));

export const clients: Client[] = files.flatMap((file) => file.clients ?? []);
export const contracts: Contract[] = files.flatMap((file) => file.contracts ?? []);
export const tools: Tool[] = files.flatMap((file) => file.tools ?? []);
export const skills: Skill[] = files.flatMap((file) => file.skills ?? []);
export const achievements: Achievement[] = files.flatMap(
  (file) => file.achievements ?? [],
);
export const recommendations: Recommendation[] = files.flatMap(
  (file) => file.recommendations ?? [],
);

export function getContractById(id: string): Contract | undefined {
  return contracts.find((contract) => contract.id === id);
}

export function getClientById(id: string): Client | undefined {
  return clients.find((client) => client.id === id);
}

export function getContractsByClient(clientId: string): Contract[] {
  return contracts.filter((contract) => contract.clientId === clientId);
}
